import { IconMinus24 } from '@cian/ui-kit';

import { FC } from 'react';

import { ControlButton } from '../internal/ControlButton';

import styles from './ZoomOut.css';

type ZoomOutProps = {
  handleClick: VoidFunction;
};

export const ZoomOut: FC<ZoomOutProps> = props => {
  const { handleClick } = props;

  return (
    <ControlButton
      className={styles['button']}
      handleClick={handleClick}
      icon={<IconMinus24 color="black_100" />}
      testId="map-controls.zoom-out"
    />
  );
};
